import { Component, OnInit } from '@angular/core';
import { RoleEnum } from '@app/shared/enum/role.enum';
import { TradeInSytemCollection } from '@app/shared/models/tradein-system.collection';
import { Store } from '@ngxs/store';
import { AuthState } from '@app/store/auth/auth.state';
@Component({
  selector: 'app-tvf',
  templateUrl: './tvf.component.html',
  styleUrls: ['./tvf.component.sass'],
})
export class TvfComponent {
  tradinSytem = TradeInSytemCollection.find((t) => t.role === RoleEnum.TVF);

  buttons: any[] = [];

  private readonly allButtons = [
    {
      icon: 'collections_bookmark',
      label: 'Triagem',
      color: '#003B71',
      route: 'triagem/buscar',
      flag: 'OTR',
    },
    {
      icon: 'description',
      label: 'Trades',
      color: '#FF6600',
      route: 'pedidos',
      flag: 'OT',
    },
    {
      icon: 'verified_user',
      label: 'Controle de Qualidade',
      color: '#003B71',
      route: 'controle-qualidade',
      flag: 'OCQ',
    },
    {
      icon: 'inventory',
      label: 'Recebimento',
      color: '#FF6600',
      route: 'recebimento',
      flag: 'ORCV',
    },
    {
      icon: 'dashboard',
      label: 'Controle de LMR',
      color: '#003B71',
      route: 'lmr',
      flag: 'CLMR',
    },
    {
      icon: 'mobile_screen_share',
      label: 'Reincidência',
      color: '#FF6600',
      route: 'reincidencia',
      flag: 'ORD',
    },
  ];

  constructor(private store: Store) {}

  ngOnInit(): void {
    const loggedUser = this.store.selectSnapshot(AuthState);

    this.buttons = this.allButtons.filter(
      (button) => loggedUser?.attributes?.[button.flag] === 'True'
    );
  }
}
